<div class="page-header-container">
    <div class="page-title">
        {{'asset.title' | translate}}
    </div>
</div>


<div class="d-flex flex-column align-items-center my-5 my-lg-0" *ngIf="!hasData">
    <no-records-placeholder
        [showNoRecordsHeader]="true"
        [isActiveFilter]="activeFilterCount > 0"
        (clickHereEvent)="resetFiltersHandler()"
    ></no-records-placeholder>
</div>

<asset-driver-list-view
    [assets]="assets"
    [props]="props"
    [navigateToDetailHandler]="navigateToDetailHandler">
</asset-driver-list-view>


<button *ngIf="showBackToTop" type="button" class="btn btn-scroll-to-top" (click)="scrollToTop()">
    <i class="app-icon icon icon-back-to-top icon-xl"></i>
</button>